import { URL } from '../../constants/provider/constant';
import { _axios } from '../../plugins/axios';

export const checkUser = (phoneNo, email) => {
    let data = {
        Phone: phoneNo,
        Email: email
    }
    let config = {
        method: 'post',
        url: URL.plus_api_prod+'CheckUser',
        data: data
    };
    return _axios(config)
        .then((response) => response.data )
        .catch((error) => error);
}

export const getAvailableCities = (categoryItemTypeId) => {
  let data = {
    CategoryItemTypeId : categoryItemTypeId,
    RequestAccessToken : JSON.parse(localStorage.getItem("access_token"))
   }
  let config = {
    method: 'post',
    url: URL.plus_api_prod+'GetAvailableCities',
    data: data
  };
  return _axios(config)
    .then((response) => response.data )
    .catch((error) => error);
}

export const getPackages = (categoryItemTypeId,city,keyword) => {
    let data = {
        CategoryItemTypeId: categoryItemTypeId,
        city: city,
        keyword: keyword
    }
    let config = {
        method: 'post',
        url: URL.plus_api_prod+'GetPackages',
        data: data
      };
      return _axios(config)
        .then((response) => response.data )
        .catch((error) => error);
}

export const createFinalOrder = (data) => {
  let config = {
      method: 'post',
      url: URL.providercore_url+'provider/createAffilateOrder',
      data:{ 
        ...data,
        accessToken: JSON.parse(localStorage.getItem("access_token"))
      }
    };
    return _axios(config)
      .then((response) => response.data )
      .catch((error) => error);
}